import React, { useEffect, useState } from 'react';
import { FormattedDate, FormattedRelative, FormattedTime } from 'react-intl';
import getIncludedResponse from '../../../helpers/getIncludedResource';
import { Button } from '../../../common/components';
import { Col, Row } from 'react-bootstrap';
import { actions } from '../../../modules/dashboard/redux/dashboardActions';
import { connect, useSelector } from 'react-redux';
import {
  dataOnly,
  setFilters,
  updateDataTable,
} from '../DataTable/redux/dataTableActions';
import { hasPermission } from '../../../modules/auth/redux/authActions';
import './NotesList.scss';

const Note = ({ row, attachments, onClear }) => {
  const handleClearReminders = () => {
    onClear(row.id);
  };
  return (
    <div className="note-item">
      <p className="notes-text">
        {row.attributes.content.split('\n').map((item, key) => {
          return (
            <span key={key}>
              {item}
              <br />
            </span>
          );
        })}
      </p>
      <Row>
        <Col sm={6}>
          {!!row?.attributes?.reminder_at && (
            <p className="reminder">
              Reminder set for{' '}
              <FormattedDate value={new Date(row.attributes.reminder_at)} />
              {/*{' '} <FormattedTime value={new Date(row.attributes.reminder)}/>*/}
            </p>
          )}
          <p className="author">
            {row.attributes.created_by_name}
            <span className="date">
              &nbsp; <FormattedDate value={new Date(row.attributes.noted_at)} />{' '}
              <FormattedTime value={new Date(row.attributes.noted_at)} /> ({' '}
              <FormattedRelative value={new Date(row.attributes.noted_at)} /> )
            </span>
          </p>
        </Col>
        <Col sm={6}>
          {row.attributes.reminder && hasPermission('system.notes_create') && (
            <Button
              bsStyle="secondary"
              className="pull-right pad-right"
              handleClick={handleClearReminders}
            >
              Clear Reminder
            </Button>
          )}
        </Col>
      </Row>

      {attachments.length > 0 ? (
        <p className="note-attachments">
          <strong>Attachments: </strong>

          {attachments.map((data, i) => {
            return (
              <span className="attachment-link" key={i}>
                <a href={data.attributes.url} target="_blank">
                  {data.attributes.name}
                </a>
                {attachments.length - 1 !== i ? <span>, &nbsp;</span> : null}
              </span>
            );
          })}
        </p>
      ) : null}
    </div>
  );
};
const NotesList = ({
  autoFilterType,
  autoFilterId,
  onRefreshData,
  onClearReminder,
  onFetch,
  resourceId,
}) => {
  const [nextPage, setNextPage] = useState(0);

  const dataTable = useSelector((state) => state.dataTables?.tables?.[resourceId]);

  const { isFetching, data, included, total } = dataTable ?? {};
  useEffect(
    () => {
      async function getData(fetchUrl) {
        onFetch(resourceId, fetchUrl);
      }
      const url = `local/notes?page[limit]=20&page[offset]=${nextPage}&include=attachments&${autoFilterType}=${autoFilterId ? autoFilterId : resourceId}`;
      if (nextPage !== 0 || (nextPage === 0 && !data)) {
        getData(url);
      }

    },
    [nextPage],
  );

  const handleClearReminders = (id) => {
    return Promise.resolve(onClearReminder(id, false)).then((resp) => {
      return onRefreshData(resourceId, resp.data, [], false);
    });
  };

  const getMore = () => {
    setNextPage(nextPage + 20);
  };

  return (
    <div className="notes-list">
      {!isFetching && data?.length === 0 && (
        <div className="notes-list--no-resulta">
          <p className="note-text">No notes to display.</p>
        </div>
      )}

      {data?.map((row, i) => {
        const attachments = getIncludedResponse(row, included, 'attachments') || [];
        return (
          <Note
            key={i}
            row={row}
            attachments={attachments}
            onClear={handleClearReminders}
          />
        );
      })}
      {isFetching && (
        <div className="notes-list--loading">
          <p className="note-text">Loading...</p>
        </div>
      )}

      {data?.length < total && (
        <div className={'notes-list--load-more'} onClick={getMore}>
          Load more notes
        </div>
      )}
    </div>
  );
};

NotesList.defaultProps = {
  autoFilterType: 'filter[resource]',
};

export default connect(
  null,
  {
    onRefreshData: updateDataTable,
    onClearReminder: actions.clearReminder,
    onFetch: dataOnly,
    onSetFilters: setFilters,
  },
)(NotesList);
